import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { usePortalQuery } from 'src/Libs/api'
import LuoxEnergyIconSvg from 'src/Libs/installation-extensions/resources/LuoxEnergySvg'
import { cloudKeysApi } from 'src/Libs/installation-rights-management'
import { CloudKeyModel } from 'src/Libs/installation-rights-management/models'
import { CloudKeyScopeFilters } from 'src/Libs/installation-rights-management/types'
import { useTypedSelector } from 'src/State/RootReducer'
import { ExtensionDetailsProps, ExtensionTypes } from '../../../types'
import { DetailsViewWrapper, HeaderContent } from '../../general'
import { FooterContent } from '../helpers'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * Gives a detailed description of the luox marketing extension. Also allows to redirect to the partner.
 */
const LuoxDirectMarketingDetails: React.FC<ExtensionDetailsProps> = ({ extensionState, onClose, place = 0 }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()

  const allowRedirect = extensionState !== 'active'
  const [luoxEnergyCloudKey, setLuoxEnergyCloudKey] = useState<CloudKeyModel>()
  const authFetch = useAuthFetchWithResponse()
  const activeInstallation = useTypedSelector(state => state.storage.activeInstallation)
  const description = isFlowTheme
    ? t('installation-extensions.direct-marketing.Modal.description.flow')
    : t('installation-extensions.direct-marketing.Modal.description')

  const { data, error, isSuccess, isError } = usePortalQuery({
    queryKey: ['cloudKeys', extensionState, cloudKeysApi, activeInstallation],
    enabled: !!extensionState && !!activeInstallation,
    queryFn: () => {
      if (!activeInstallation) {
        throw new Error('Active installation is undefined')
      }
      return cloudKeysApi.findAll(activeInstallation, authFetch, CloudKeyScopeFilters.LuoxEnergy)
    },
  })

  useEffect(() => {
    if (isError) {
      console.error(error)
      return
    }
    if (data && isSuccess) {
      if (data) setLuoxEnergyCloudKey(data[0])
    }
  }, [data, error, isSuccess, isError])

  return (
    <DetailsViewWrapper
      extensionType={ExtensionTypes.LuoxOne}
      descriptions={[description]}
      headerContent={<HeaderContent logo={<LuoxEnergyIconSvg />} />}
      footerContent={<FooterContent allowRedirect={allowRedirect} cloudKey={luoxEnergyCloudKey} extensionState={extensionState} />}
      onClose={onClose}
      place={place}
      open={true}
      category={{ name: 'direct-marketing', paletteColor: theme.palette.olive }}
    />
  )
}

export default LuoxDirectMarketingDetails
